import { render, staticRenderFns } from "./abilityList.vue?vue&type=template&id=5f0a0396&"
import script from "./abilityList.vue?vue&type=script&lang=js&"
export * from "./abilityList.vue?vue&type=script&lang=js&"
import style0 from "./abilityList.vue?vue&type=style&index=0&id=5f0a0396&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports